import { Header,Services, About, Contact,Products } from '../components'

const HomePage  = ()  => {
    return (
        <main>
            <Header icon='fas fa-home page-icon'/>
            <Services />
            <About />
            <Products />
            <Contact />
        </main>
    )
}


export default HomePage;